import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "filter-list-el" }
const _hoisted_2 = { class: "row justify-left full-width q-py-none no-wrap" }
const _hoisted_3 = { class: "q-py-none" }
const _hoisted_4 = { class: "q-mt-xs q-px-xs" }
const _hoisted_5 = { class: "q-py-none" }
const _hoisted_6 = { class: "q-mt-xs q-px-xs" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = {
  key: 4,
  class: "row no-wrap items-baseline"
}
const _hoisted_12 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_AccessFilterDropdownContent = _resolveComponent("AccessFilterDropdownContent")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_selector_popup = _resolveComponent("selector-popup")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_date_range_display_item = _resolveComponent("date-range-display-item")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_variable_display_list = _resolveComponent("variable-display-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.theModel.Descriptor !== 5 && _ctx.theModel.Descriptor !== 7 && _ctx.theModel.Descriptor !== 11)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            ref: "triggerBtn",
            class: "q-my-none unset-items-center",
            flat: "",
            dense: "",
            round: "",
            icon: "add",
            size: "sm",
            color: "grey-8",
            onClick: _ctx.addNewFilter,
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
            onMouseup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
            "aria-label": _ctx.$t('add_filter')
          }, null, 8, ["onClick", "aria-label"]))
        : _createCommentVNode("", true),
      (
          _ctx.isAccessFilter ||
          (_ctx.theModel.Descriptor === 1 && _ctx.theModel.Category !== 6) ||
          [3, 4, 9, 10].includes(_ctx.theModel.Descriptor)
        )
        ? (_openBlock(), _createBlock(_component_selector_popup, {
            key: 1,
            visible: _ctx.isShowingMenu,
            "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isShowingMenu) = $event)),
            "trigger-el": _ctx.$refs.triggerBtn,
            "default-width": _ctx.isAccessFilter ? _ctx.accessFilterDropdownWidth : 300,
            "max-height": _ctx.isAccessFilter ? _ctx.accessFilterDropdownHeight : 500,
            "wide-layout": _ctx.filterListSelectorWideLayout
          }, {
            default: _withCtx(() => [
              (_ctx.isAccessFilter)
                ? (_openBlock(), _createBlock(_component_AccessFilterDropdownContent, {
                    key: 0,
                    modelValue: (_ctx.theModel as any).Filters,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (((_ctx.theModel as any).Filters) = $event)),
                    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowingMenu = false))
                  }, null, 8, ["modelValue"]))
                : (_ctx.theModel.Descriptor === 4)
                  ? (_openBlock(), _createBlock(_component_aux_selector, {
                      key: 1,
                      ref: "aux_selector",
                      modelValue: (_ctx.theModel as SelectionParametersFilterGroupSend).Parameters,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((_ctx.theModel as SelectionParametersFilterGroupSend).Parameters) = $event)),
                      "input-index": _ctx.inputIndex,
                      "model-type": _ctx.theModel.Category === 12 ? 3 : _ctx.theModel.Category,
                      "use-refactored-recursive": true,
                      "limit-height-to-container": true,
                      "open-on-start": true,
                      "allow-multiple": true,
                      onSelectorClosed: _ctx.onPanelClosed
                    }, null, 8, ["modelValue", "input-index", "model-type", "onSelectorClosed"]))
                  : (_openBlock(), _createBlock(_component_aux_selector, {
                      key: 2,
                      ref: "aux-selector",
                      modelValue: (_ctx.theModel as filterTypes).Filters,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((_ctx.theModel as filterTypes).Filters) = $event)),
                      "input-index": _ctx.inputIndex,
                      "exclude-id": _ctx.genstore?.selectedItem?.Id,
                      "use-refactored-recursive": true,
                      "model-type": 
            _ctx.theModel.Descriptor === 9 ? 22 : 
            (_ctx.theModel.Category === 12 ? 3 : 
              (_ctx.theModel.Descriptor === 10 ? 23 : _ctx.theModel.Category))
          ,
                      "limit-height-to-container": true,
                      "allow-multiple": true,
                      onSelectorClosed: _ctx.onPanelClosed
                    }, null, 8, ["modelValue", "input-index", "exclude-id", "model-type", "onSelectorClosed"]))
            ]),
            _: 1
          }, 8, ["visible", "trigger-el", "default-width", "max-height", "wide-layout"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_item_section, { class: "q-my-xs" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([
                'row justify-left full-width q-py-0',
                { 'no-wrap': ![1, 3, 9, 10].includes(_ctx.theModel.Descriptor) },
              ])
              }, [
                _createVNode(_component_q_item_label, {
                  class: _normalizeClass([{ 'text-red cursor-pointer': _ctx.isIncorrect }, 'q-mr-xs'])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getElementName) + " ", 1),
                    (_ctx.isIncorrect)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, {
                          key: 0,
                          delay: 300,
                          anchor: "top middle",
                          self: "center middle"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.isIncorrect), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]),
                (
                  !_ctx.isOwnerFilter &&
                  _ctx.theModel.FilterConnector &&
                  (_ctx.theModel as filterTypes).Filters?.length > 1
                )
                  ? (_openBlock(), _createBlock(_component_q_btn_toggle, {
                      key: 0,
                      modelValue: _ctx.theModel.FilterConnector,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.theModel.FilterConnector) = $event)),
                      class: _normalizeClass([
                  'filter-andor-toggle q-pa-none q-my-none',
                  { 'q-mr-none': _ctx.theModel.Descriptor === 3 },
                ]),
                      style: {"margin-top":"-3px"},
                      "no-caps": "",
                      unelevated: "",
                      dense: "",
                      "toggle-color": "primary",
                      color: "white",
                      "text-color": "primary",
                      options: [
                  { label: _ctx.$t('or_label'), value: 1 },
                  { label: _ctx.$t('and_label'), value: 2 },
                ]
                    }, null, 8, ["modelValue", "class", "options"]))
                  : _createCommentVNode("", true),
                (_ctx.theModel.Descriptor === 3)
                  ? (_openBlock(), _createBlock(_component_q_checkbox, {
                      key: 1,
                      modelValue: _ctx.useInnerModel,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.useInnerModel) = $event)),
                      "toggle-indeterminate": false,
                      "keep-color": false,
                      "checked-icon": "event",
                      "unchecked-icon": "event",
                      size: "sm",
                      color: "primary",
                      style: {"margin-top":"-10px"},
                      class: "q-mx-none q-px-none cursor-pointer"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.theModel.Descriptor === 9 && _ctx.theModel.Filters?.length)
                  ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                      key: 2,
                      modelValue: _ctx.theModel.CalculateFiguresOnlySelectedStorages,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.theModel.CalculateFiguresOnlySelectedStorages) = $event)),
                      "toggle-indeterminate": false,
                      style: {"margin-top":"-1px","margin-left":"3px"},
                      label: _ctx.$t('calc_by_selected'),
                      class: "q-mx-none q-px-none cursor-pointer"
                    }, null, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true),
                (_ctx.theModel.Descriptor === 10 && _ctx.theModel.Filters?.length)
                  ? (_openBlock(), _createBlock(_component_q_option_group, {
                      key: 3,
                      class: "q-ml-xs",
                      dense: "",
                      inline: "",
                      multiple: "",
                      "model-value": _ctx.moveFlagSetConditions.map((el) => el.value),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = (val) => { _ctx.changeMoveFlagModel(val)}),
                      options: _ctx.movementFlagOptions,
                      size: "xs",
                      color: "primary",
                      type: "checkbox"
                    }, null, 8, ["model-value", "options"]))
                  : (_ctx.theModel.Descriptor === 14)
                    ? (_openBlock(), _createBlock(_component_q_select, {
                        key: 4,
                        flat: "",
                        modelValue: _ctx.moveTypeModel,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.moveTypeModel) = $event)),
                        "hide-bottom-space": "",
                        multiple: "",
                        "label-slot": false,
                        "bottom-slots": false,
                        dense: "",
                        outlined: "",
                        class: "thin-input no-padding-inside q-ml-xs",
                        style: {"min-width":"100px","margin-top":"-5px"},
                        "input-debounce": "500",
                        label: 
                !_ctx.moveTypeModel || !_ctx.moveTypeModel.length
                  ? _ctx.$t('filter_empty')
                  : ''
                ,
                        ref: "move_type_select",
                        "hide-dropdown-icon": false,
                        "options-html": "",
                        options: _ctx.moveTypeOptions
                      }, null, 8, ["modelValue", "label", "options"]))
                    : _createCommentVNode("", true),
                (_ctx.theModel.Descriptor === 3 && _ctx.useInnerModel)
                  ? (_openBlock(), _createBlock(_component_date_range_display_item, {
                      key: 5,
                      modelValue: _ctx.innerRange,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.innerRange) = $event)),
                      modelType: _ctx.theModel.Descriptor,
                      "shift-top": true
                    }, null, 8, ["modelValue", "modelType"]))
                  : _createCommentVNode("", true),
                (
                  _ctx.theModel.Descriptor === 1 &&
                  _ctx.commonRoleOptions &&
                  _ctx.commonRoleOptions.length
                )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      onClick: _cache[13] || (_cache[13] = ($event: any) => ((_ctx.$refs.roles_select as any).showPopup())),
                      class: "cursor-pointer q-mx-sm text-bold text-grey-8",
                      style: {"margin-top":"-2px"}
                    }, " # "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel.Descriptor === 1
                  ? _ctx.commonRolesModel
                  : [], (role, ri) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row no-wrap",
                    key: ri,
                    style: {"float":"left","margin-right":"5px","margin-top":"-2px"}
                  }, [
                    _createElementVNode("div", null, _toDisplayString(role.label), 1),
                    _createVNode(_component_q_btn, {
                      class: "q-pa-none q-ma-none",
                      flat: "",
                      dense: "",
                      "aria-label": _ctx.$t('remove'),
                      icon: "close",
                      size: "xs",
                      onClick: 
                    () => {
                      _ctx.commonRolesModel = _ctx.commonRolesModel.filter(
                        (el, index) => index != ri
                      );
                    }
                  
                    }, null, 8, ["aria-label", "onClick"])
                  ]))
                }), 128)),
                (
                  _ctx.theModel.Descriptor === 1 &&
                  _ctx.commonRoleOptions &&
                  _ctx.commonRoleOptions.length
                )
                  ? (_openBlock(), _createBlock(_component_q_select, {
                      key: 7,
                      flat: "",
                      modelValue: _ctx.commonRolesModel,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.commonRolesModel) = $event)),
                      class: "no-select-border q-mb-xs",
                      "hide-bottom-space": "",
                      "fill-input": "",
                      multiple: "",
                      "label-slot": false,
                      "bottom-slots": false,
                      dense: "",
                      outlined: "",
                      style: 'max-width: 40vw; max-height: 0; overflow: hidden;',
                      "input-debounce": "500",
                      label: "",
                      ref: "roles_select",
                      "hide-dropdown-icon": true,
                      options: _ctx.commonRoleOptions
                    }, {
                      "no-option": _withCtx(() => [
                        _createVNode(_component_q_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { class: "text-grey" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("no_data_found")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_item_section, {
          class: "q-my-xs",
          style: {"flex-wrap":"nowrap"}
        }, {
          default: _withCtx(() => [
            ([0, 1, 2, 3, 8, 9, 10, 12, 14, 15].includes(_ctx.theModel.Descriptor))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_variable_display_list, {
                    modelValue: (_ctx.theModel as filterTypes).Filters,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (((_ctx.theModel as filterTypes).Filters) = $event)),
                    onItemDeleted: _ctx.deleteItem,
                    modelType: _ctx.displayFilterDescriptor,
                    modelCategory: _ctx.theModel.Category === 12 ? 3 : _ctx.theModel.Category,
                    "role-options": (_ctx.theModel as SelectionEntityWithRolesFilterGroupSend).Roles?.map((el) => {
              return {
                label: el.Name,
                value: el
              }
            })
                  }, null, 8, ["modelValue", "onItemDeleted", "modelType", "modelCategory", "role-options"])
                ]))
              : (_ctx.theModel.Descriptor === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_variable_display_list, {
                      modelValue: (_ctx.modelValue as SelectionParametersFilterGroupSend).Parameters,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (((_ctx.modelValue as SelectionParametersFilterGroupSend).Parameters) = $event)),
                      onItemDeleted: _ctx.deleteItem,
                      modelType: _ctx.theModel.Descriptor,
                      modelCategory: _ctx.theModel.Category === 12 ? 3 : _ctx.theModel.Category,
                      "display-selected": true
                    }, null, 8, ["modelValue", "onItemDeleted", "modelType", "modelCategory"])
                  ]))
                : (_ctx.theModel.Descriptor === 5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_q_select, {
                        flat: "",
                        modelValue: _ctx.jobStatusModel,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.jobStatusModel) = $event)),
                        class: "no-select-border q-mb-xs",
                        "hide-bottom-space": "",
                        multiple: "",
                        "label-slot": false,
                        "bottom-slots": false,
                        dense: "",
                        outlined: "",
                        clearable: "",
                        "input-debounce": "500",
                        label: 
                !_ctx.jobStatusModel || !_ctx.jobStatusModel.length
                  ? _ctx.$t('filter_empty')
                  : ''
              ,
                        ref: "job_status_select",
                        "hide-dropdown-icon": false,
                        options: _ctx.jobStatusOptions
                      }, {
                        "no-option": _withCtx(() => [
                          _createVNode(_component_q_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("no_data_found")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "label", "options"])
                    ]))
                  : (_ctx.theModel.Descriptor === 7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_q_select, {
                          flat: "",
                          modelValue: _ctx.tagStatusModel,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tagStatusModel) = $event)),
                          class: "no-select-border q-mb-xs",
                          "hide-bottom-space": "",
                          multiple: "",
                          "label-slot": false,
                          "bottom-slots": false,
                          dense: "",
                          outlined: "",
                          "input-debounce": "500",
                          label: 
                !_ctx.tagStatusModel || !_ctx.tagStatusModel.length
                  ? _ctx.$t('filter_empty')
                  : ''
              ,
                          ref: "tag_status_select",
                          "hide-dropdown-icon": false,
                          options: _ctx.tagStatusOptions
                        }, {
                          "no-option": _withCtx(() => [
                            _createVNode(_component_q_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("no_data_found")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "options"])
                      ]))
                    : (_ctx.theModel.Descriptor === 11)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_q_select, {
                            flat: "",
                            modelValue: _ctx.moveTypeModel,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.moveTypeModel) = $event)),
                            class: "no-select-border q-mb-xs",
                            "hide-bottom-space": "",
                            multiple: "",
                            "label-slot": false,
                            "bottom-slots": false,
                            dense: "",
                            outlined: "",
                            "input-debounce": "500",
                            label: 
                !_ctx.moveTypeModel || !_ctx.moveTypeModel.length
                  ? _ctx.$t('filter_empty')
                  : ''
              ,
                            ref: "move_type_select",
                            "hide-dropdown-icon": false,
                            "options-html": "",
                            options: _ctx.moveTypeOptions
                          }, {
                            "no-option": _withCtx(() => [
                              _createVNode(_component_q_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("no_data_found")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "label", "options"])
                        ]))
                      : (_ctx.theModel.Descriptor === 6)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_q_select, {
                              flat: "",
                              modelValue: _ctx.attachStatusModel,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.attachStatusModel) = $event)),
                              class: "no-select-border q-mb-xs",
                              "hide-bottom-space": "",
                              multiple: "",
                              "label-slot": false,
                              "bottom-slots": false,
                              dense: "",
                              outlined: "",
                              clearable: "",
                              "input-debounce": "500",
                              label: 
                !_ctx.attachStatusModel || !_ctx.attachStatusModel.length
                  ? _ctx.$t('filter_empty')
                  : ''
              ,
                              ref: "attach_status_select",
                              "hide-dropdown-icon": false,
                              options: _ctx.attachStatusOptions
                            }, {
                              "no-option": _withCtx(() => [
                                _createVNode(_component_q_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("no_data_found")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "label", "options"])
                          ]))
                        : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}